<template>
  <div>
    <div class="col-12 mt-2" v-if="book.chapters.length > 0">
      <p class="text-center">قسمت ها</p>
      <fvTable
        class="fv-size-lg"
        v-if="book.chapters.length > 0"
        :fields="fields"
        :rows="book.chapters"
      >
        <template slot="field-#" , slot-scope="scope">
          <span>{{ scope.index + 1 }}</span>
        </template>
        <template slot="field-نام کتاب" slot-scope="scope">
          {{ scope.row.bookName || "---" }}
        </template>
        <template slot="field-نام فصل" slot-scope="scope">
          <div v-html="scope.row.chapterName || '---'" />
        </template>
        <template slot="field-تاریخ ثبت" slot-scope="scope">
          {{ $dateTimeFormat(scope.row.createTime) }}
        </template>
        <template slot="field-actions" slot-scope="scope">
          <button
            @click="deleteChapter(scope.row.chapterId)"
            class="btn btn-danger btn-sm"
          >
            حذف
            <i class="fa fa-trash" />
          </button>
        </template>
      </fvTable>
    </div>
    <div class="col-12 mt-2" v-else>
      <p class="text-center">این کتاب هیچ قسمتی ندارد.</p>
    </div>
    <!-- <div v-if="showEdit">
      <div class="col-12 col-lg-4 mb-3">
        <div class="form-group text-right">
          <label for="title">عنوان</label>
          <input
            id="title"
            type="text"
            class="form-control"
            placeholder="عنوان"
          />
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { API_URL2 } from "../../env";

export default {
  data() {
    const { params } = this.$route;
    const { id } = params;
    return {
      id,
      fields: ["#", "نام کتاب", "نام فصل", "تاریخ ثبت", "actions"],
      baseUrl: API_URL2,
      showEdit: false
    };
  },
  props: ["book", "bookId"],
  methods: {
    async deleteChapter(chapterId) {
      try {
        const token = Vue.$cookies.get("accessToken");
        console.log("deleted ID", chapterId);
        const bookId = this.bookId;
        console.log("fucking bookId", bookId);
        const result = await axios.delete(
          `${this.baseUrl}/panel/chapter/book/set/${bookId}/${chapterId}`,
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        );
        console.log("deleted", result);
      } catch (error) {
        console.log(error);
      }
    },
    showEdit() {
      this.showEdit = true;
    }
  },
  created: {}
};
</script>
